<table *ngIf="guestsData" class="guests-grid">
    <tr>
        <th *ngIf="!isBadgeExtension"><span appEllipsisTooltip>Photo</span></th>
        <th><span appEllipsisTooltip>First name</span></th>
        <th><span appEllipsisTooltip>Last name</span></th>
        <th><span appEllipsisTooltip>Mobile number</span></th>
        <th><span appEllipsisTooltip>Email</span></th>
        <th><span appEllipsisTooltip>Company</span></th>
        <th><span appEllipsisTooltip>Visa type</span></th>
        <th><span appEllipsisTooltip>Business function</span></th>
        <th><span appEllipsisTooltip>Visit start</span></th>
        <th><span appEllipsisTooltip>Visit end</span></th>
        <th><span appEllipsisTooltip>No of days</span></th>
        <th>
            <i class="icon-notification-bell"></i>
        </th>
    </tr>

    <tbody>
    <ng-container *ngFor="let guest of guestsData; let index = index">
        <tr *ngIf="index !== guestIndex">
            <td *ngIf="!isBadgeExtension">
                <img
                    [src]="guest.photoInfo ? (guest.photoInfo['file'] ? guest.photoInfo['file']?.url : defaultImageUrl) : defaultImageUrl"
                    alt="">
            </td>
            <td><span appEllipsisTooltip>{{ guest.firstName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.lastName }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.phoneNumber }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.emailAddress }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.company }}</span></td>
            <td><span appEllipsisTooltip>{{ guest.visaTypeId | findByName: visaTypes }}</span></td>
            <td *ngIf="businessFunctions?.length"><span
                appEllipsisTooltip>{{ guest.entityOrFssId | findByName : businessFunctions : 'employeeFunctionId' }}</span>
            </td>
            <td>{{ guest.visitStart | date: 'M/d/yy' }}</td>
            <td>{{ guest.visitEnd | date: 'M/d/yy' }}</td>
            <td>{{ guest.visitStart | numOfDays: guest.visitEnd }}</td>
            <td>
                <i
                    *ngIf="guest.notification; else iconPlaceholder"
                    class="icon-comment"
                    [tooltip]="guest.notification"
                    [placement]="'right'"
                ></i>
                <i
                    class="icon-edit"
                    [class.disabled]="guestToEdit || !showAddGuestButton"
                    [tooltip]="'Edit visitor'"
                    (click)="openEditGuest(guest, index)"
                ></i>
                <i
                    class="icon-delete"
                    [class.disabled]="guestToEdit || !showAddGuestButton"
                    [tooltip]="'Delete visitor'"
                    (click)="deleteGuest(guest)"
                ></i>
            </td>
        </tr>
        <tr *ngIf="isEdit && index === guestIndex" class="edit-row">
            <td [attr.colspan]="!isBadgeExtension ? 12 : 11">
                <employee-edit-guest
                    (guestEdited)="editGuest($event)"
                    (cancel)="cancel($event)"
                    [guestData]="guestToEdit"
                    [isBadgeExtension]="isBadgeExtension"
                ></employee-edit-guest>
            </td>
        </tr>
    </ng-container>

    </tbody>
</table>

<button
    class="button text with-icon add-button"
    *ngIf="showAddGuestButton"
    [class.disabled]="guestToEdit"
    (click)="addNewGuest()">
    <i class="icon-plus"></i>
    Add new visitor
</button>

<ng-template #iconPlaceholder>
    <i class="icon-placeholder"> </i>
</ng-template>
